import { Box, Container, Flex } from 'components/box';
import { Theme, css } from '@emotion/react';
import RichText from 'components/rich-text';

const descriptionStyles = (theme: Theme) => css`
  gap: ${theme.space[3]}px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700 !important;
    font-family: ${theme.fonts.header} !important;
    line-height: 1.2 !important;
    color: ${theme.colors.black} !important;

    width: 100% !important;
    line-height: 1.1;
    padding-bottom: 0.8em;
  }

  h1 {
    font-size: ${theme.fontSizes[4]};
  }

  h2 {
    font-size: ${theme.fontSizes[3]};
  }

  h3,
  h4,
  h5 {
    font-size: ${theme.fontSizes[2]};
  }

  p,
  li {
    line-height: 1.6em !important;
    width: 100% !important;
  }

  p {
    margin-bottom: 0.8em !important;
  }

  p:last-child {
    margin-bottom: 0 !important;
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
  }

  ul,
  ol {
    margin: 0 0 1em;
    padding-left: 2em;
    width: 100% !important;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  img {
    max-width: 100%;
  }

  @media ${theme.mediaQueries.mobileDown} {
    p {
      line-height: 1.4rem !important;
      margin-bottom: 0.5em !important;
      font-size: 0.9rem !important;
    }
  }
`;

const SeoDescription = ({ description }: { description: string }) => (
  <Box px={3} mt={[3, null, 4]} mb={4}>
    <Container py={3}>
      <Flex flexDirection="column" css={descriptionStyles}>
        <RichText content={description} />
      </Flex>
    </Container>
  </Box>
);

export default SeoDescription;
